import axiosInstance from "../utils/axiosInstance";

/**
 * Signatories are the people a community puts its own name to on approvals and
 * inspection records - replacing the old hardcoded Lakeside reviewer list.
 *
 * A logged-in Community user always gets their own list; the API resolves it
 * from the token. An Admin reviewing on a community's behalf passes communityId.
 */

export const fetchSignatories = async ({ communityId = null, product = null, includeInactive = false } = {}) => {
  try {
    const params = {};
    if (communityId) params.communityId = communityId;
    if (product) params.product = product;
    if (includeInactive) params.includeInactive = true;

    const response = await axiosInstance.get("/signatories", { params });
    return response.data?.signatories || [];
  } catch (error) {
    console.error("Error fetching signatories:", error);
    throw error;
  }
};

export const createSignatory = async (payload) => {
  try {
    const response = await axiosInstance.post("/signatories", payload);
    return response.data;
  } catch (error) {
    console.error("Error creating signatory:", error);
    throw error;
  }
};

export const updateSignatory = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/signatories/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating signatory:", error);
    throw error;
  }
};

export const deleteSignatory = async (id, communityId = null) => {
  try {
    const response = await axiosInstance.delete(`/signatories/${id}`, {
      params: communityId ? { communityId } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error removing signatory:", error);
    throw error;
  }
};

export const setDefaultSignatory = async (id, communityId = null) => {
  try {
    const response = await axiosInstance.put(`/signatories/${id}/default`, communityId ? { communityId } : {});
    return response.data;
  } catch (error) {
    console.error("Error setting default signatory:", error);
    throw error;
  }
};
